const queryString = require('query-string');
const params = queryString.parse(location.search);
const REGEX = /[\d]{4}(?:-[\d]{2}){2}T[\d]{2}:[\d]{2}:[\d]{2}.*/;
const isValid = REGEX.test(params.now);

export default Object.assign(
    {
        disableTimeFilter: false,
    },
    params,
    {
        date() {
            return params.now && isValid
                ? new Date(params.now)
                : new Date();
        }
    }
);
